import React from 'react';
import styled from 'styled-components';
import { Link } from 'react-router-dom';

const MissionPage = () => {
  return (
    <Container>
      <Content>
        <Title>Our Mission</Title>
        <Text>
          We're building a future where technology works for educators, not against them.
          Our goal is to empower every teacher with AI tools that enhance their natural abilities,
          letting them focus on what matters most: inspiring and guiding students.
        </Text>
        <CTAButton to="/signup">
          Get Early Access
        </CTAButton>
      </Content>
    </Container>
  );
};

const Container = styled.div`
  background: #0A1628;
  min-height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 20px;
`;

const Content = styled.div`
  max-width: 800px;
  text-align: center;
`;

const Title = styled.h1`
  font-size: 56px;
  color: white;
  margin-bottom: 32px;
`;

const Text = styled.p`
  font-size: 24px;
  line-height: 1.5;
  color: rgba(255, 255, 255, 0.8);
  margin-bottom: 48px;
`;

const CTAButton = styled(Link)`
  display: inline-block;
  background: #3AB7FF;
  color: white;
  padding: 16px 32px;
  border-radius: 12px;
  font-size: 18px;
  font-weight: 600;
  text-decoration: none;
  transition: all 0.2s ease;

  &:hover {
    transform: translateY(-2px);
    background: #50c1ff;
  }
`;

export default MissionPage; 